jQuery(document).ready(function($){
    if ($('.collection-item__header').length){
        $('.collection-item__header').matchHeight();
    }


    // if ($('[id*=featured-collection] .grid-product__title').length){
    //     $('[id*=featured-collection] .grid-product__title').matchHeight();
    // }
})